import { useCallback, useEffect, useState } from 'react';
import api from '../../utils/functions/api';

const API = process.env.REACT_APP_API_URL;

// แผนบัญชีของ AI provider ('free' | 'paid' | '') → ข้อความแสดงผล — ใช้ร่วมกันทุกที่ที่ต้องโชว์ว่าฟรีหรือไม่
export const aiPlanLabel = (plan, uiLang = 'th') => {
  if (plan === 'free') return uiLang === 'en' ? 'Free' : 'ฟรี';
  if (plan === 'paid') return uiLang === 'en' ? 'Paid' : 'เสียเงิน';
  return uiLang === 'en' ? 'Plan not set' : 'ไม่ระบุแผน';
};

// รายการ AI ที่เรียกใช้ได้จริง (มี adapter + มี key) จาก backend GET /api-provider/options — ไม่มีค่า key ปนมา
// [{ provider_key, display_name, plan, key_count, id, default_model }]
export function useAiProviderOptions() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const { data } = await api.get(`${API}/api-provider/options`);
      setOptions(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e?.response?.data?.message || e?.message || 'load failed');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { options, loading, error, reload };
}
